import { useIsAuthenticated } from '@azure/msal-react';
import { SignOutButton } from './SignOutButton';
import { FAQButton } from './FAQButton';

export const PageLayout = (
  props: React.PropsWithChildren<{
    showReturnToPageSelected: boolean;
    handleReturnToPageSelection: Function;
    activeNavigationPage: Common.AdminNavigation;
  }>
) => {
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      {isAuthenticated ? (
        <>
          <SignOutButton
            showReturnToPageSelected={props.showReturnToPageSelected}
            handleReturnToPageSelection={props.handleReturnToPageSelection}
          />
          {props.activeNavigationPage === 'Menu' && <FAQButton />}
        </>
      ) : (
        <>
          <p className='pl-4 pt-4'>Redirecting to Drax Energy...</p>
        </>
      )}
      {props.children}
    </>
  );
};
